import LeftNavItem from "../../components/leftNav/leftNavItem";
import styles from "./leftNav.module.scss";
import { useState } from "react";

function LeftNav({ items }) {
  const [currentSelection, setCurrentSelection] = useState(0);
  return (
    <nav className={styles.root}>
      <ul className={styles.menu}>
        {items.map((item, index) => {
          return (
            <LeftNavItem
              lastItem={index === items.length - 1}
              blok={item}
              key={index}
              selected={index === currentSelection}
              onSelected={() => setCurrentSelection(index)}
            />
          );
        })}
      </ul>
    </nav>
  );
}

export default LeftNav;
